/*
  input: void 
  output: {'00:00 to 02:00': { per: 0, routeName: '' }, '02:00 to 04:00': { per: 0, routeName: '' }}
*/
function getTimeObj() {
  let timeObj = {};
  const timeObjValue = { per: 0, routeName: "" }
  for(let i=0; i < 24; i+=2) {
    const from = (i < 10 ? "0" : "") + i + ":00"
    const to = (i+2 < 10 ? "0" : "") + (i+2) + ":00"
    timeObj[`${from} to ${to}`]={...timeObjValue};
  }
  return timeObj
}

export function modifyEmptyChartData(data) {
  let timeObj = getTimeObj()
  let modulesData = {};
  Object.keys(data).forEach(function(moduleName) {
    let ResultArray = [];
    data[moduleName].forEach((ele) => {
      if (ele.emptyTime) {
        const timeInHr = new Date(Date.parse(ele.emptyTime)).getHours();
        timeObj = convertData(timeInHr, timeObj, ele.routeName);
      }
    });
    for (let keys in timeObj) {
      const per = (data[moduleName].length !== 0) ? (timeObj[keys]["per"] / data[moduleName].length) * 100 : 0;
      let temp = {};
      temp["name"] = keys;
      temp["value"] = per;
      temp["routeName"] = timeObj[keys]["routeName"].slice(0, -3);
      ResultArray.push(temp);
    }
    modulesData[moduleName] = ResultArray;
  });
  return modulesData;
}
export function removeTrapRoute(data) {
  let modulesData = {};
  Object.keys(data).forEach(function(moduleName) {
    modulesData[moduleName] = data[moduleName]?.filter(ele => !ele.isTrapRoute);
  });
  return modulesData;
}
export function timeConvert(data) {
  let modulesData = {};
  Object.keys(data).forEach(function(moduleName) {
    modulesData[moduleName] = data[moduleName]?.map((ele) => {
      if (ele.stopTime) {
        let hours = Math.floor(ele.stopTime / 60);
        let minutes = ele.stopTime % 60;
        ele.stopTime = hours + "." + minutes;
        return ele;
      } else {
        return ele;
      }
    });
  });
  return modulesData;
}

/*
  input: hour
  output: '00:00 to 02:00' 
  description: It will generate a key for given hour
*/
function getTimeObjKey(hour) {
  let newHour = (hour % 2 == 0) ? hour-2 : hour-1;
  if (newHour < 0) newHour = 0;
  const from = ('0' + newHour).slice(-2) + ":00";
  const to = ('0' + (newHour+2)).slice(-2) + ":00";
  return `${from} to ${to}`;
}

function convertData(hours, timeObj, RN) {
  let newTimeObj = {...timeObj};
  const timeKey = getTimeObjKey(hours);
  newTimeObj[timeKey]["per"]++;
  newTimeObj[timeKey]["routeName"] += RN + " , ";
  return newTimeObj;
}